import { DropdownIndicatorProps, GroupBase } from 'react-select';
import clsx from 'clsx';

export const CustomDropdownIndicator = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  selectProps,
}: DropdownIndicatorProps<Option, IsMulti, Group>) => {
  const { isDisabled, menuIsOpen } = selectProps;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={clsx('text-content-base-default', {
        'text-input-background-disabled': isDisabled,
      })}
      style={{
        transform: menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.29674 10.4544L11.5728 14.2775C11.6256 14.3391 11.6911 14.3885 11.7649 14.4224C11.8386 14.4563 11.9187 14.4738 11.9999 14.4738C12.081 14.4738 12.1612 14.4563 12.2349 14.4224C12.3086 14.3885 12.3741 14.3391 12.4269 14.2775L15.703 10.4544C16.0156 10.0894 15.7564 9.52576 15.276 9.52576H8.72283C8.24236 9.52576 7.98315 10.0894 8.29674 10.4544Z"
        fill="currentColor"
      />
    </svg>
  );
};
